import { mapActions, mapState } from '@/store/helpers';
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import {
    UPDATE_CONDITION,
    CENTER_DEL_CONDITION,
    CENTER_DEL_KEYWORD,
    CENTER_DEL_INPUT_BOX,
    CENTER_DEL_SUGGESTION, 
    REMOVE_KEYWORD_MUTATION,
    MAP_CHANGE_MUTATION
} from '@/components/search-result/_store/types';
import * as TYPES from '../_store/types';
import util from '@/common/util';
import {
    ADD_KEYWORD_MUTATION,
    OTHER_URL_QUERY_MUTATION
} from '../../md-search/_store/config';

import dispatchCondition from '@/components/search-result/_mixins/dispatch-condition';
import { mapAsyncData } from '../../../plugins/asyncData';
import { search, searchCenter } from '../asyncData';
import { getMoreFieldsCenter } from '../_util'

const common = {
    i18next: {
        ns: 'md-search-bar'
    },
    mixins: [dispatchCondition(false)],
    computed: {
        ...mapState({
            keywords: store => store.keywords,
            fetcherData: store => store.fetcherData,
            outsideFields: store => store.outsideFields,
            searchCharts: store => store.searchCharts,
            conditions: store => store.conditions,
            showOutFields: store => store.showOutFields
        }),
        isEmbed() {
            return window.parent && window.parent !== window;
        }
    },
    methods: {
        ...mapActions({
            initConditionMutation: TYPES.INITIAL_CONDITION,
            addKeywordMutation: ADD_KEYWORD_MUTATION,
            mapChangeMutation: MAP_CHANGE_MUTATION,
            removeKeywordMutation: REMOVE_KEYWORD_MUTATION,
            otherUrlQueryMutation: OTHER_URL_QUERY_MUTATION,
            resetSearchMutation: TYPES.SEARCH_RESET_MUTATION,
            clearAllCondition: TYPES.CLEAR_ALL_CONDITION
        })
    }
};
const index = {
    mixins: [...common.mixins],
    data: function() {
        return {
            showLocation: true, // only use search center, just avoid error
            showMoreBtn: true, // only use search center, just avoid error
            searchQueryOnUrl: null,
            locationQueryOnUrl: '',
            // unknownQueryOnUrl: {},
            urlPresetParams: null,
            mapConditionOnUrl: {
                rect: '',
                mapPath: '',
                mapSearch: false,
                zoom: 14,
                threshold: 10
            }
        };
    },
    computed: {
        ...common.computed,
        ...mapState({
            conditionSort: store => store.conditionSort
        }),
        ...mapState(['searchParamsWithMap', 'moduleMap'])
    },
    methods: {
        ...common.methods,
        ...mapActions({
            updateConditionMutation: UPDATE_CONDITION,
            resetMobileCondition: TYPES.RESET_MOBILE_CONDITION
        }),
        reset() {
            this.resetMobileCondition({ isMobileSize: this.isMobileSize, theme: this.theme });
            this.dispatchConditions({
                init: false,
                kee: 'reset'
            });
        },
        mergeCondition: mapAsyncData(search.mergeCondition),
        listenCMSChange() {
            window.addEventListener('message', e => {
                if (e.data.action === 'cms_update_condition') {
                    let kee = e.data.data.kee;
                    if (kee === 'key') {
                        const oldValue = util.deepClone(this.keywords);
                        let value = e.data.data.value || '';
                        let data = null;
                        if (value) {
                            value = value.split(':');
                            data = {
                                keyword: value.slice(1).join(':'),
                                keywordType: value[0]
                            };
                        }
                        this.removeKeywordMutation(data);
                        this.dispatchConditions({
                            init: false,
                            kee: 'key',
                            value: util.deepClone(this.keywords),
                            oldValue
                        });
                    } else if (kee === 'mapPath') {
                        this.mapChangeMutation({
                            mapPath: null
                        });
                        this.dispatchConditions({
                            init: false,
                            kee: 'mapPath',
                            value: null
                            // oldValue
                        });
                    } else if (kee === 'mapRadius') {
                        this.mapChangeMutation({
                            mapRadius: null
                        });
                        this.dispatchConditions({
                            init: false,
                            kee: 'mapRadius',
                            value: null
                            // oldValue
                        });
                    } else if (kee === 'mapSearch') {
                        this.mapChangeMutation({
                            mapSearch: false
                        });
                        this.dispatchConditions({
                            init: false,
                            kee: 'mapSearch',
                            value: false
                            // oldValue
                        });
                    } else {
                        const conditions = this.conditions
                        const oldValue = util.deepClone(
                            conditions[e.data.data.dn]
                        );
                        this.updateConditionMutation(e.data.data);
                        const newValue = util.deepClone(
                            conditions[e.data.data.dn]
                        );
                        this.dispatchConditions({
                            init: false,
                            kee: e.data.data.dn,
                            value: newValue,
                            oldValue
                        });
                    }
                }
            });
        },
        setWatchers() {
            if (this.isEmbed && !this.forCMS) {
                this.$watch(
                    'presetFilters',
                    () => {
                        this.clearAllCondition();
                        this.mergeCondition();
                        this.dispatchConditions({
                            init: true,
                            oldValue: null,
                            value: this.searchParamsWithMap,
                            kee: null
                        });
                    },
                    {
                        deep: true
                    }
                );
            }
        },
        updateCustomListingSourceHandler() {
            function isCustomSource(source) {
                return (
                    source &&
                    !['all listings', 'sold listings'].includes(source)
                );
            }
            window.addEventListener('message', e => {
                if (e.data.action === 'cms_update_custom_listing_source') {
                    const updateSource = e.data.data;
                    if (
                        this.listingSource &&
                        this.listingSource === updateSource &&
                        isCustomSource(updateSource)
                    ) {
                        // update custom listing source
                        this.clearAllCondition();
                        this.mergeCondition();
                        this.dispatchConditions({
                            init: true,
                            oldValue: null,
                            value: this.searchParamsWithMap,
                            kee: null
                        });
                    }
                }
            });
        }
    },
    beforeMount() {
        this.listenCMSChange();
        this.setWatchers();
        this.updateCustomListingSourceHandler();
    }
};
const indexCenter = {
    mixins: [...common.mixins],
    inject: ['searchTheme'],
    data: function() {
        return {
            urlPresetParams: null,
            conditionOnUrl: {},
            uiConfig: {}
        };
    },
    computed: {
        ...common.computed,
        ...rootMapState(usePageStore, {
            isSearchCenter: store => store.isSearchCenter
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        showLocation() {
            return this.fetcherData?.location?.condition;
        },
        showMoreBtn() {
            if (this.fetcherData && this.fetcherData.rawConf) {
                return (
                    this.fetcherData.rawConf.reduce((memo, cur) => {
                        memo = [...memo, ...(cur.conditions || [])];
                        return memo;
                    }, []).length > 0
                );
            } else {
                return false;
            }
        }
    },
    methods: {
        ...common.methods,
        ...mapActions({
            centerComputedPresetFilter: TYPES.CENTER_COMPUTED_PRESET_FILTER,
            centerDelCondition: CENTER_DEL_CONDITION,
            centerDelKeyword: CENTER_DEL_KEYWORD,
            centerDelInputBox: CENTER_DEL_INPUT_BOX,
            centerDelSuggestion: CENTER_DEL_SUGGESTION,
            resetKeywords: TYPES.RESET_KEY_WORDS
        }),
        ...mapActions({
            centerCommitCondition: TYPES.CENTER_COMMIT_CONDITION
        }),
        _initPresetParams: mapAsyncData(searchCenter.initPresetParams),
        initPresetParams() {
            this._initPresetParams();
            this.dispatchConditions({
                init: true,
                oldValue: null,
                value: this.searchParamsWithMap,
                kee: 'init'
            });
        },
        mergeCondition: mapAsyncData(searchCenter.mergeCondition),
        setPresetConditionStatus(status) { },
        reset() {
            this.resetSearchMutation(
                getMoreFieldsCenter({ theme: this.searchTheme || this.theme, isMobileSize: this.isMobileSize, outsideFields: this.showOutFields })
            );
            this.theme === 'broker' && this.resetKeywords();

            this.dispatchConditions({
                init: false,
                kee: 'reset'
            });
        },
        listenCMSChange() {
            if (this.forCMS) {
                window.addEventListener('message', e => {
                    if (e.data.action === 'cms_update_condition') {
                        const data = e.data.data;
                        let name = data.dn;
                        if (name.toLowerCase() === 'location') {
                            const [type, value] = data.delTag.split(':');
                            if (type === 'mapPath') {
                                this.mapChangeMutation({
                                    mapPath: null
                                });
                                this.dispatchConditions({
                                    init: false,
                                    kee: 'mapPath',
                                    value: null
                                });
                            } else if (type === 'mapRadius') {
                                this.mapChangeMutation({
                                    mapRadius: null
                                });
                                this.dispatchConditions({
                                    init: false,
                                    kee: 'mapRadius',
                                    value: null
                                });
                            } else if (type === 'mapSearch') {
                                this.mapChangeMutation({
                                    mapSearch: false
                                });
                                this.dispatchConditions({
                                    init: false,
                                    kee: 'mapSearch',
                                    value: false
                                });
                            } else {
                                const oldValue = util.deepClone(this.keywords);
                                this.removeKeywordMutation({
                                    keyword: value,
                                    keywordType: type
                                });
                                this.dispatchConditions({
                                    init: false,
                                    kee: 'key',
                                    value: util.deepClone(this.keywords),
                                    oldValue
                                });
                            }
                        } else {
                            const conditions = this.conditions
                            const oldValue = util.deepClone(
                                conditions[data.dn]
                            );
                            if (data.delTag === -1) {
                                this.centerDelCondition(data.dn);
                            } else {
                                switch (data.inputType) {
                                case 'keyWord':
                                    this.centerDelKeyword({
                                        name: data.dn,
                                        delTag: data.delTag
                                    });
                                    break;
                                case 'inputBox':
                                    this.centerDelInputBox({
                                        name: data.dn,
                                        delTag: data.delTag
                                    });
                                    break;
                                case 'suggestion':
                                    this.centerDelSuggestion({
                                        name: data.dn,
                                        delTag: data.delTag
                                    });
                                    break;
                                default:
                                    break;
                                }
                            }
                            const newValue = util.deepClone(
                                conditions[data.dn]
                            );
                            this.dispatchConditions({
                                init: false,
                                kee: data.dn,
                                value: newValue,
                                oldValue
                            });
                        }
                    }
                });
            }
        },
        setWatchers() {
            if (this.isEmbed && !this.forCMS) {
                this.$watch(
                    'presetFiltersV2',
                    () => {
                        this.clearAllCondition();
                        this.initPresetParams();
                        this.dispatchConditions({
                            init: true,
                            oldValue: null,
                            value: this.searchParamsWithMap,
                            kee: null
                        });
                    },
                    {
                        deep: true
                    }
                );
            }
        },
        // fix-cms use custom listing source  modify custom filter when ， won't trigger search ， because filtername no change 
        updateCustomListingSourceHandler() {
            function isCustomSource(source) {
                return (
                    source &&
                    !['all listings', 'sold listings'].includes(source)
                );
            }
            window.addEventListener('message', e => {
                if (e.data.action === 'cms_update_custom_listing_source') {
                    const updateSource = e.data.data;
                    if (
                        this.listingSource &&
                        this.listingSource === updateSource &&
                        isCustomSource(updateSource)
                    ) {
                        // update custom listing source
                        this.clearAllCondition();
                        this.initPresetParams();
                        this.dispatchConditions({
                            init: true,
                            oldValue: null,
                            value: this.searchParamsWithMap,
                            kee: null
                        });
                    }
                }
            });
        }
    },
    created() {
        this.listenCMSChange();
        this.setWatchers();
        this.updateCustomListingSourceHandler();
    }
};

export { index, indexCenter };
